<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card shadow-sm border border-3">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small> Enter with your access </small>
          </div>
          <form role="form" @submit.prevent="handleSubmit()">
            <base-input
              alternative
              class=" mb-3"
              placeholder="Email"
              v-model="email"
              name="Email"
            >
            </base-input>
            <validation-error :errors="apiValidationErrors.email" />

            <div class="position-relative">
              <base-input
                alternative
                class=""
                placeholder="Password"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                name="Password"
              >
              </base-input>
              <button 
                type="button"
                class="toggle-password-btn"
                @click="togglePassword"
              >
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <validation-error :errors="apiValidationErrors.password" />

            <base-checkbox class="custom-control-alternative">
              <span>Remember me</span>
            </base-checkbox>
            <div class="text-center">
              <base-button
                type="primary"
                native-type="submit"
                class="my-4 submit"
                :disabled="load"
                >Enter</base-button
              >
            </div>
            <p style="font-size: 14px">
              Dont have an account?
              <router-link to="/register" style="color: #007bff;"> request access </router-link>
            </p>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <router-link to="/password/reset" class="text-light"
            ><small>Forgot your password?</small></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ui/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
export default {
  name: "login",
  components: {
    ValidationError,
  },
  mixins: [formMixin],
  data: () => ({
    email: "",
    password: "",
    load: false,
    showPassword: false,
  }),
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
  },
  methods: {
    async handleSubmit() {
      this.load = true;
      const user = {
        username: this.email,
        password: this.password,
        grant_type: "password",
        client_secret: "50kmnTpYXXvMmRIIgBtSCZnIcly9zmNIIWdtCZKe",
        client_id: 2,
      };
      const requestOptions = {
        headers: {},
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });
        this.load = false;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Invalid credentials",
          horizontalAlign: "center",
        });
        this.load = false;
        // this.setApiValidation(error.response.data.errors);
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
.position-relative {
  position: relative;
}

.toggle-password-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #8898aa;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.toggle-password-btn:hover {
  color: #525f7f;
}
</style>
